import { defineComponent as _defineComponent } from 'vue'
import { useBuilderStore } from '@/store/builder';
import { ref } from 'vue';
import { userChangeBuilderId } from '@/util/functions'
import { useAuth } from '@/store/auth';
import SimpleModal from './SimpleModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuilderMissingModal',
  emits: ["close"],
  setup(__props, { expose: __expose }) {
  __expose();



const builders = useBuilderStore();
const auth = useAuth();

const selectedBuilder = ref<null | string>(null);
const loading = ref(false);
const done = ref(false);
const error = ref<null | string>(null);

const doSelect = async () => {
    if(!selectedBuilder.value) return;

    loading.value = true;
    try {
        await userChangeBuilderId({builderId: selectedBuilder.value});
        await auth.reloadClaims();
        done.value = true;
    } catch (e) {
        console.error(e);
        error.value = (e as Error).message;
    } finally {
        loading.value = false;
    }
}
const doReload = () => {
    window.location.reload();
}

const __returned__ = { builders, auth, selectedBuilder, loading, done, error, doSelect, doReload, get useBuilderStore() { return useBuilderStore }, ref, get userChangeBuilderId() { return userChangeBuilderId }, get useAuth() { return useAuth }, SimpleModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})